import React, { useEffect, useState } from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Textarea } from '../../components/ui/textarea';
import { Label } from '../../components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from '../../components/ui/dialog';
import { publicApi, adminApi } from '../../api/client';
import { toast } from '../../hooks/use-toast';
import { Plus, Pencil, Trash2, Loader2 } from 'lucide-react';

const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
const empty = { slug: '', name: '', image: '', description: '', order: 0 };

const AdminTours = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);

  const load = async () => { setLoading(true); try { setItems(await publicApi.getTours()); } catch {} setLoading(false); };
  useEffect(() => { load(); }, []);

  const upd = (k) => (e) => setForm({ ...form, [k]: k === 'order' ? parseInt(e.target.value || 0) : e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    try {
      const payload = { ...form, slug: form.slug || slugify(form.name) };
      if (editing) await adminApi.updateTour(editing.id, payload); else await adminApi.createTour(payload);
      toast({ title: 'Saved' }); setOpen(false); load();
    } catch (err) { toast({ title: 'Save failed', description: err.response?.data?.detail, variant: 'destructive' }); }
  };

  const del = async (item) => { if (!window.confirm(`Delete "${item.name}"?`)) return; try { await adminApi.deleteTour(item.id); load(); } catch { toast({ title: 'Delete failed', variant: 'destructive' }); } };

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div><h1 className="font-serif text-3xl text-[#304b71]">Tour Categories</h1><p className="text-slate-500 text-sm mt-1">Homepage tour category tiles.</p></div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button onClick={() => { setEditing(null); setForm(empty); setOpen(true); }} className="bg-[#304b71] hover:bg-[#6a8aa4] text-white"><Plus size={16} className="mr-1" /> New Tour</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle className="font-serif text-[#304b71]">{editing ? 'Edit' : 'New'} Tour Category</DialogTitle></DialogHeader>
            <form onSubmit={submit} className="space-y-4">
              <div><Label>Name *</Label><Input required value={form.name} onChange={upd('name')} className="mt-1" /></div>
              <div><Label>Slug</Label><Input value={form.slug} onChange={upd('slug')} placeholder={slugify(form.name)} className="mt-1" /></div>
              <div><Label>Image URL *</Label><Input required value={form.image} onChange={upd('image')} className="mt-1" /></div>
              <div><Label>Description</Label><Textarea rows={3} value={form.description} onChange={upd('description')} className="mt-1" /></div>
              <div><Label>Order</Label><Input type="number" value={form.order} onChange={upd('order')} className="mt-1" /></div>
              <DialogFooter><Button type="button" variant="outline" onClick={() => setOpen(false)}>Cancel</Button><Button type="submit" className="bg-[#304b71] hover:bg-[#6a8aa4] text-white">Save</Button></DialogFooter>
            </form>
          </DialogContent>
        </Dialog>
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 overflow-hidden">
        {loading ? <div className="py-20 text-center"><Loader2 className="animate-spin inline text-[#304b71]" /></div> :
          <table className="w-full text-sm">
            <thead className="text-xs uppercase text-slate-500 bg-[#f6f8fa]"><tr><th className="text-left px-5 py-3">Name</th><th className="text-left">Slug</th><th className="text-left">Order</th><th className="text-right px-5">Actions</th></tr></thead>
            <tbody>{items.map((t) => (
              <tr key={t.id} className="border-t border-slate-100">
                <td className="px-5 py-3"><div className="flex items-center gap-3"><img src={t.image} alt="" className="w-14 h-14 object-cover rounded-lg" /><div className="font-serif text-[#304b71]">{t.name}</div></div></td>
                <td className="text-slate-500">{t.slug}</td>
                <td className="text-slate-600">{t.order}</td>
                <td className="text-right px-5 space-x-1"><Button size="sm" variant="outline" onClick={() => { setEditing(t); setForm(t); setOpen(true); }}><Pencil size={14} /></Button><Button size="sm" variant="outline" className="text-rose-600 border-rose-200" onClick={() => del(t)}><Trash2 size={14} /></Button></td>
              </tr>
            ))}</tbody>
          </table>
        }
      </div>
    </div>
  );
};

export default AdminTours;
